/*
 * @Descripttion: 获取当前时间
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-08-27 09:20:33
 * @LastEditors: hayuu
 * @LastEditTime: 2024-08-27 09:35:11
 */

/********** 获取当前时间--开始 **********/
let currentTime = "";
let currentDate = "";
let currentWeek = "";
export function getCurrentTime() {
    const date = new Date();
    return formatCurrentTime(date);
}

export function formatCurrentTime(date) {
    // 获取当前时间并打印
    const yy = date.getFullYear();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    const hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    const mf =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    const ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    const week = date.getDay();
    const weekArr = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
    ];

    currentTime = hh + ":" + mf + ":" + ss;
    // currentTime = hh + ":" + mf;
    // currentDate = yy + "-" + mm + "-" + dd;
    currentDate = mm + "月" + dd + "日";
    currentWeek = weekArr[week];
    return { currentTime, currentDate, currentWeek }
}
/********** 获取当前时间--结束 **********/
